import { useState } from 'react'

// icons
import { RxCross2 } from 'react-icons/rx'
import { LuUpload } from 'react-icons/lu'
import { FaCircleCheck } from 'react-icons/fa6'
import { MdDelete } from 'react-icons/md'
import { Icon } from '@iconify/react'

import { Dropdown, Button, Typography, Drawer, Upload, message } from 'antd'
import { IoIosArrowDown } from 'react-icons/io'

// context
import { useUpload } from '../../../context/UploadResumeContext'

// constants
import { JOB_APPLICATIONS_STATUS } from '../../../constants/jobs'

import ManuallyCandidateAdd from '../../candidate/components/manually-candidate-add'
import '../index.css'
import styles from './AddCandidate.module.css'

export default function AddCandidatesDropdown({ state }) {
    const { Text } = Typography

    const [openResumeDrawer, setOpenResumeDrawer] = useState(false)
    const [fileList, setFileList] = useState([])
    const [openManuallyModel, setOpenManuallyModel] = useState(false)

    const { addUploads } = useUpload()

    const menuItems = [
        {
            key: 'add_resume',
            label: (
                <div className={styles.menuItem}>
                    <span className={styles.menuItemIcon}>
                        <Icon icon="mdi:file-upload-outline" width={18} />
                    </span>
                    <span className={styles.menuItemText}>
                        <Text className={styles.menuItemTitle}>Add Resume</Text>
                        <Text className={styles.menuItemDesc}>
                            Add candidate with resume
                        </Text>
                    </span>
                </div>
            ),
        },
        {
            key: 'add_manual',
            label: (
                <div className={styles.menuItem}>
                    <span className={styles.menuItemIcon}>
                        <Icon icon="mdi:account-edit-outline" width={18} />
                    </span>
                    <span className={styles.menuItemText}>
                        <Text className={styles.menuItemTitle}>
                            Add Manually
                        </Text>
                        <Text className={styles.menuItemDesc}>
                            Enter candidate name and details
                        </Text>
                    </span>
                </div>
            ),
        },
    ]
    const onClick = ({ key }) => {
        if (key === 'add_resume') {
            setOpenResumeDrawer(true)
        } else if (key === 'add_manual') {
            setOpenManuallyModel(true)
        }
    }

    return (
        <>
            <div className={styles.triggerWrap}>
                <Dropdown
                    menu={{ items: menuItems, onClick }}
                    trigger={['click']}
                    overlayClassName={`add-candidates-menu ${styles.menu}`}
                >
                    <Button
                        type="primary"
                        size="middle"
                        className={styles.triggerBtn}
                    >
                        <span className={styles.triggerContent}>
                            <Icon
                                icon="mdi:plus"
                                width={18}
                                height={18}
                                className={styles.triggerIcon}
                            />
                            <span className={styles.triggerLabel}>
                                Add Candidates
                            </span>
                            <IoIosArrowDown
                                size={14}
                                className={styles.triggerChevron}
                            />
                        </span>
                    </Button>
                </Dropdown>
            </div>
            <Drawer
                open={openResumeDrawer}
                onClose={() => {
                    setFileList([])
                    setOpenResumeDrawer(false)
                    setOpenManuallyModel(false)
                }}
                width={650}
                placement="bottom"
                className={styles.resumeDrawer}
                closeIcon={null}
                styles={{
                    body: {
                        padding: undefined,
                    },
                    content: {
                        height: '80vh',
                    },
                    wrapper: {
                        minHeight: '80vh',
                        borderRadius: '18px 18px 0px 0px',
                    },
                }}
                title={
                    <div className={styles.drawerHeader}>
                        <div className={styles.drawerHeaderLeft}>
                            <div className={styles.drawerHeaderIcon}>
                                <Icon
                                    icon="mdi:file-upload-outline"
                                    width={20}
                                    height={20}
                                />
                            </div>
                            <div>
                                <div className={styles.drawerHeaderTitle}>
                                    Add candidate
                                </div>
                                <div className={styles.drawerHeaderSubtitle}>
                                    Upload resume files to create candidates
                                </div>
                            </div>
                        </div>
                        <div className={styles.drawerHeaderActions}>
                            {fileList?.length > 0 && (
                                <div className={styles.uploadAction}>
                                    <button
                                        type="button"
                                        className={styles.uploadActionMain}
                                        onClick={() => {
                                            addUploads(
                                                fileList,
                                                'applied',
                                                state?.jobStatus
                                            )
                                            setFileList([])
                                            setOpenResumeDrawer(false)
                                        }}
                                    >
                                        Add to Applied
                                    </button>
                                    <Dropdown
                                        menu={{
                                            items: JOB_APPLICATIONS_STATUS.map(
                                                (status) => ({
                                                    key: status.value,
                                                    label: status.label,
                                                })
                                            ),
                                            onClick: ({ key }) => {
                                                addUploads(fileList, key)
                                                setFileList([])
                                                setOpenResumeDrawer(false)
                                            },
                                        }}
                                        trigger={['click']}
                                        placement="bottomRight"
                                    >
                                        <button
                                            type="button"
                                            className={styles.uploadActionChevron}
                                            aria-label="Choose status"
                                        >
                                            <IoIosArrowDown size={14} />
                                        </button>
                                    </Dropdown>
                                </div>
                            )}
                            <button
                                type="button"
                                className={styles.closeBtn}
                                onClick={() => setOpenResumeDrawer(false)}
                                aria-label="Close"
                            >
                                <RxCross2 size={16} />
                            </button>
                        </div>
                    </div>
                }
            >
                <div className={styles.drawerBody}>
                    <p className={styles.drawerLead}>
                        Add candidates with resume
                    </p>

                    <div className={styles.uploaderCard}>
                        <Upload.Dragger
                            multiple
                            maxCount={100}
                            accept=".pdf"
                            beforeUpload={(file) => {
                                const allowed = /\.(pdf)$/i.test(file.name)
                                if (!allowed) {
                                    message.error('Only .pdfs are allowed.')
                                    return Upload.LIST_IGNORE
                                }
                                if (file.size > 5 * 1024 * 1024) {
                                    message.error(
                                        'File must be smaller than 5MB.'
                                    )
                                    return Upload.LIST_IGNORE
                                }
                                return false
                            }}
                            onChange={({ fileList: list }) => setFileList(list)}
                            fileList={fileList}
                            showUploadList={false}
                            className={styles.dragger}
                        >
                            {fileList.length > 0 ? (
                                <div className={styles.fileList}>
                                    {fileList.map((file) => (
                                        <div
                                            key={file.uid}
                                            className={styles.fileRow}
                                        >
                                            <div className={styles.fileRowLeft}>
                                                <FaCircleCheck
                                                    color="#059669"
                                                    size={16}
                                                />
                                                <Typography.Text
                                                    className={styles.fileName}
                                                >
                                                    {file.name}
                                                </Typography.Text>
                                            </div>

                                            <Button
                                                type="text"
                                                danger
                                                icon={
                                                    <MdDelete
                                                        color="#64748b"
                                                        size={18}
                                                    />
                                                }
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    setFileList((prev) =>
                                                        prev.filter(
                                                            (f) =>
                                                                f.uid !==
                                                                file.uid
                                                        )
                                                    )
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className={styles.draggerIcon}>
                                    <LuUpload />
                                </div>
                            )}

                            <p className={styles.draggerMain}>
                                <Typography.Text
                                    strong
                                    style={{ color: '#4f46e5' }}
                                >
                                    Upload a file
                                </Typography.Text>
                                <Typography.Text>
                                    {' '}
                                    or drag and drop here
                                </Typography.Text>
                            </p>
                        </Upload.Dragger>

                        <p className={styles.draggerHint}>
                            Upload up to 100 files, maximum file size 5MB,
                            acceptable file types .pdf.
                        </p>
                    </div>
                </div>
            </Drawer>
            {openManuallyModel && (
                <ManuallyCandidateAdd
                    openManuallyModel={openManuallyModel}
                    setOpenManuallyModel={setOpenManuallyModel}
                    state={state}
                />
            )}
        </>
    )
}
